import request from '@/system/engine/request';
import config from '@/system/engine/config';
import {getLocalStorage} from '@/system/store/localstorage';
var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
// history
export function historyAjaxTable(limit,pagination,id,created_at,valid_at,completed_at,group_id,master_id,coin_id,price,capital,balance,total_usdt,is_active,login){
	const data = request({
		url: config.url+'history/ajaxTable?limit=' + limit + '&pagination=' + pagination + '&id=' + id + '&created_at=' + created_at + '&valid_at=' + valid_at + '&completed_at=' + completed_at + '&group_id=' + group_id +'&master_id=' + master_id + '&coin_id=' + coin_id + '&price=' + price + '&capital=' + capital + '&balance=' + balance + '&total_usdt=' + total_usdt + '&is_active=' + is_active + '&login=' + login,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function packageLog(refer_id,limit,pagination){
	const data = request({
		url: config.url+'history/packageLog?language='+language+'&refer_id=' + refer_id +'&limit=' + limit + '&pagination=' + pagination,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function packageInfo(id){
	const data = request({
		url: config.url+'history/info?language='+language+'&id=' + id,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function entrustRecall(postData){
	const data = request({
		url: config.url+'history/recall',
		method: 'post',
		data:postData
	});

	return Promise.resolve(data);
}

// new
export function getNewRegister(){
	
	const data = request({
		url: config.url+'register/register?language=' + language,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function newRegister(postData){
	const data = request({
		url: config.url+'register/new',
		method: 'post',
		data: postData
	});

	return Promise.resolve(data);
}

export function checkSponsor(sponsor){
	const data = request({
		url: config.url+'register/checkSponsor?sponsor=' + sponsor,
		method: 'get'
	});

	return Promise.resolve(data);
}